var heading_default = {
  "fontElementMap": "EXjr4",
  "elementSpacing": "YhA7j",
  "headerOne": "TeEFo YhA7j",
  "headerTwo": "_55-PX YhA7j",
  "headerThree": "llf4c YhA7j",
  "headerFour": "Q0SAY YhA7j",
  "headerFive": "_9kxhc YhA7j",
  "headerSix": "Rw8dK YhA7j",
  "child": "D3hOm"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
